<template>
    <div>
        <modal ref="modal" :has-footer="false">
            <div class="d-block text-center" slot="title" v-if="!form.block">Add New Contact</div>
            <div class="d-block text-center" slot="title" v-else>Add New Blocked Contact</div>
            <div class="animated animated-normal fadeIn" :key="key">
                <div class="form-group">
                    <div>
                        <div class="row">
                            <div class="col">
                                <input-text tabindex="1" label="Name" placeholder="Name" v-model="form.name" :form="form"
                                            field="name" autofocus></input-text>
                            </div>
                            <div class="col">
                                <input-text tabindex="2" label="Phone" placeholder="Phone" v-model="form.phone_number"
                                            :form="form" field="phone_number"></input-text>
                            </div>
                        </div>
                        <input-text tabindex="3" type="email" label="Email" placeholder="Email" v-model="form.email" :form="form"
                                    field="email"></input-text>

                        <div class="form-group">
                            <label>Location(s)</label>

                            <multiselect
                                    v-model="form.locations"
                                    placeholder="Search or add a location"
                                    track-by="id"
                                    label="name"
                                    :options="locations"
                                    :multiple="true"
                                    :taggable="true"
                                    @input="updateGroups"
                                    :max="teamConfig.single_contact_per_location ? 1 : 99999"
                            >
                                <span v-if="teamConfig.single_contact_per_location" slot="maxElements">Only one location can be selected</span>
                            </multiselect>

                            <p class="notification-error" v-if="form && form.errors.has('locations')">
                                {{ form.errors.get('locations') }}
                            </p>
                        </div>

                        <div class="form-group">
                            <label>Group(s)</label>

                            <multiselect
                                    v-model="form.groups"
                                    placeholder="Search or add a group"
                                    track-by="id"
                                    label="name"
                                    :options="groups"
                                    :multiple="true">
                            </multiselect>

                            <p class="notification-error" v-if="form && form.errors.has('groups')">
                                {{ form.errors.get('groups') }}
                            </p>
                        </div>

                    </div>
                </div>
                <div class="form-row">
                    <div class="col">
                        <button-loading class="btn btn-primary btn-block" type="button" :loading="form.submitting"
                                        @click="saveContact">Save
                        </button-loading>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import Form from "../../utils/Form";

    export default {
        data() {
            return {
                key       : null,
                locations : [],
                groups    : [],
                form      : new Form({}),
                teamConfig: {},
            };
        },

        async created() {
            await this.fetchTeamConfig();
            await this.fetchLocations();
            await this.fetchGroups();

            window.Bus.$on('openAddNewContactModal', (data) => {
                this.$refs.modal.open();
                this.setupForm(data);
                this.key = Math.random().toString(36);
            });
        },

        methods: {
            setupForm(data) {
                this.selectedLocation = null;

                this.form = new Form({
                    name        : data ? data.name : null,
                    phone_number: data ? data.phone_number : null,
                    email       : data ? data.email : null,
                    locations   : this.checkOneLocation(),
                    groups      : null,
                    block       : data ? data.block : null,
                });
            },

            async fetchLocations() {
                return this.$http.get(this.$laroute.route('api.locations.select'))
                    .then(({data}) => {
                        this.locations = data.data;
                        this.checkOneLocation();
                    });
            },

            async fetchGroups() {
                return this.$http.get('/groups-list')
                    .then(({data}) => {
                        this.groups = data;
                    });
            },

            updateGroups() {
                let params = {locations : this.form.locations.map(location => location.id)};
                return this.$http.get('/groups-list',{params})
                    .then((response) => {
                        this.groups = response.data;
                    });
            },

            saveContact() {
                this.form.post(this.$laroute.route('api.contacts.store'))
                    .then(() => {
                        this.$refs.modal.close();
                        const message = this.form.block ? 'New Blocked Contact Added' : 'New Contact Added';
                        this.$alert({message, type: 'success', title: 'Success!'});
                        window.Bus.$emit(this.form.block ? 'LoadBlockedContactList' : 'LoadContactList');
                        this.$emit('saved', this.form.phone_number);
                    })
                    .catch(({data}) => {
                        swal.fire({
                            title: data.title,
                            text : data.message,
                            type : 'error',
                        })
                    });
            },

            checkOneLocation() {
                if (this.locations.length === 1) return [this.locations[0]];

                return null
            },

            async fetchTeamConfig() {
                const { data } = await this.$http.get(this.$laroute.route('api.teams.current-team-config'));
                this.teamConfig = data.data;
            },
        }
    }
</script>

<style scoped>
    .notification-error {
        font-size: 0.9em;
        color: #db3a4a;
    }
</style>
